var React = require('react');

function ErrorInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.5 44C35.3741 44 45 34.3741 45 22.5C45 10.6259 35.3741 1 23.5 1C11.6259 1 2 10.6259 2 22.5C2 34.3741 11.6259 44 23.5 44Z","stroke":"#1C3133","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15 14L33 32","stroke":"#1C3133","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M15 32L33 14","stroke":"#1C3133","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ErrorInline.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none"};

module.exports = ErrorInline;

ErrorInline.default = ErrorInline;
